import { render, staticRenderFns } from "./BoxWhatToExpect.vue?vue&type=template&id=b0697b92&scoped=true&"
import script from "./BoxWhatToExpect.vue?vue&type=script&lang=js&"
export * from "./BoxWhatToExpect.vue?vue&type=script&lang=js&"
import style0 from "./BoxWhatToExpect.vue?vue&type=style&index=0&id=b0697b92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0697b92",
  null
  
)

export default component.exports
import {QCard,QCardSection,QCarousel,QCarouselSlide,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QCarousel,QCarouselSlide,QBtn})
